module.exports = __webpack_public_path__ + "static/media/H3_tekstblok boskoffer.0fe9d856.png";